import { get } from 'lodash'

export const headers = (intl = {}) => [
  intl.formatMessage({
    id: 'table.id'
  }),
  intl.formatMessage({
    id: 'table.first_name'
  }),
  intl.formatMessage({
    id: 'table.last_name'
  }),
  intl.formatMessage({
    id: 'table.email'
  }),
  intl.formatMessage({
    id: 'award.gold_level'
  }),
  intl.formatMessage({
    id: 'award.silver_level'
  }),
  intl.formatMessage({
    id: 'award.bronze_level'
  }),
  intl.formatMessage({
    id: 'table.last_log_added'
  }),
  intl.formatMessage({
    id: 'moduleTitle.award_leader'
  }),
  intl.formatMessage({
    id: 'table.award_unit'
  }),
  intl.formatMessage({
    id: 'table.nao'
  }),
  intl.formatMessage({
    id: 'table.participant_state'
  }),
  intl.formatMessage({
    id: 'table.labels'
  })
]

export const line = (data = []) =>
  data.map(item => ({
    line: [
      item.globalId || item.id,
      item.firstName,
      item.lastName,
      item.email,
      item.goldAwardState ? item.goldAwardState.translationText : '---',
      item.silverAwardState ? item.silverAwardState.translationText : '---',
      item.bronzeAwardState ? item.bronzeAwardState.translationText : '---',
      item.lastActivityDate,
      item.currentAwardLeaderName,
      item.goldAwardOrganizationName ||
        item.silverAwardOrganizationName ||
        item.bronzeAwardOrganizationName,
      item.goldAwardNaoIcLevelOrganizationParentName ||
        item.silverAwardNaoIcLevelOrganizationParentName ||
        item.bronzeAwardNaoIcLevelOrganizationParentName,
      item.personState.translationText,
      item.labels && item.labels.length > 1 ? item.labels.map((item) => { return get(item, 'label.name') }).join(',') : get(item.labels[0], 'label.name')
    ]
  }))
